import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { requestFromStore } from "@/services/stores/request-forms-store";
import { Stores } from "@/services/stores/types";
import { userStore } from "@/services/stores/user-store";
import { getLogLevel } from "@/utils/get-log-level";
import { LoggingLevel } from "@/utils/logger/constants";
import { contractsStore } from "@/services/stores/contracts-store";
import { documentsStore } from "@/services/stores/documents-store";
import { applicationsStore } from "@/services/stores/applications-store";
import { inboxStore } from "@/services/stores/inbox-store";
import { personnelsStore } from "@/services/stores/personnels-store";

export const useBoundStore = create<Stores>()(
  devtools(
    immer((...a) => ({
      ...applicationsStore(...a),
      ...userStore(...a),
      ...requestFromStore(...a),
      ...contractsStore(...a),
      ...documentsStore(...a),
      ...inboxStore(...a),
      ...personnelsStore(...a),
    })),
    { enabled: getLogLevel() <= LoggingLevel.Warning },
  ),
);
